{
    "date": "28-8-2021",
    "hour": "17:00",
    "topic": "",
    "policy": "",
    "claim": "",
    "agreement": true,
    "errors": {},
    "source": null
}